import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Modal, Button, TextArea, Form } from "semantic-ui-react";
import { toast } from "react-semantic-toasts";
import { makePrivateApiCall } from "utilities/dist/api";
import { setInvoiceNotes } from "../document-upload/actions";

const AddNoteModal = ({ invoiceId, open, onDismissModal }) => {
    const [note, setNote] = useState("");
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const handleAddNote = () => {
        setLoading(true);
        makePrivateApiCall({
            method: "POST",
            data: { note },
            url: `/invoice/${invoiceId}/note`,
        })
            .then(res => {
                setLoading(false);
                setNote("");
                dispatch(setInvoiceNotes(res.data.notes));
                onDismissModal();
            })
            .catch(() => {
                setLoading(false);
                toast({
                    description: "Error adding a note",
                    time: 3000,
                    type: "error",
                    icon: "warning sign",
                    title: "Error",
                });
            });
    };

    return (
        <Modal size="small" open={open}>
            <Modal.Header>Add Private Note</Modal.Header>
            <Modal.Content>
                <Form>
                    <label>Note</label>
                    <TextArea
                        fluid
                        autoFocus
                        size="large"
                        value={note}
                        onChange={e => setNote(e.target.value)}
                    />
                </Form>
            </Modal.Content>

            <Modal.Actions>
                <Button negative content="Cancel" onClick={onDismissModal} />
                <Button
                    positive
                    content="Add"
                    disabled={!note}
                    onClick={handleAddNote}
                    loading={loading}
                />
            </Modal.Actions>
        </Modal>
    );
};

export default AddNoteModal;
